


import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AppMap extends Vue {
  @Prop({default: false})
  public infoContainerOpened!: boolean;

  @Prop({default: false})
  public objectOpened!: boolean;
}
